export default "__VITE_ASSET__C2r5_rLy__"